// api.js
import { axiosDefault, axiosWAuth } from './axios';
import axios from 'axios';

let config = null;

class ApiRequest {
  constructor(args) {
    const { url = '/', method = 'post', payload = null, isAuth = false, cancelToken = null } = args;
    this.url = url;
    this.method = method;
    this.payload = payload;
    this.isAuth = isAuth;
    this.cancelToken = cancelToken;
  }

  run = async () => {
    if (!config) {
      config = await axios.get('./config/runtime.json').then(conf => conf.data);
    }

    const axiosFunc = this.isAuth ? axiosWAuth : axiosDefault;
    return axiosFunc(config, this.cancelToken)[this.method](this.url, this.payload);
  };
}

export const fetchFormFieldData = async (field, tab, cancelToken) => {
  let url = '/api/v1/' + field + (tab ? `?tab=${tab}` : '');
  const request = new ApiRequest({ url, isAuth: true, cancelToken });
  const response = await request.run();
  return response.data;
};


export const createScheduledReportQuery = async (reportname, payload) => {
  const url = `/api/v1/ScheduledReport/CreateNew?scheduledReportName=${reportname}`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: payload
  });
  const response = await request.run();
  return response.data;
};


export const search = async (endpoint, body, cancelToken) => {
  const url = '/api/v1/' + endpoint;
  const request = new ApiRequest({ url, payload: body, isAuth: true, cancelToken });
  const response = await request.run();
  return response.data;
};
export const deleteSavedSearch = async id => {
  const url = `/api/v1/SavedSearches/DeleteSavedSearch?id=${id}`;
  const request = new ApiRequest({
    url,
    isAuth: true
  });
  const response = await request.run();
  return response.data;
};
export const saveSearch = async payload => {
  const url = "/api/v1/SavedSearches/SaveSearch";
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: payload
  });
  const response = await request.run();
  return response.data;
};
export const updateSavedSearch = async payload => {
  const url = "/api/v1/SavedSearches/UpdateSavedSearch";
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: payload
  });
  const response = await request.run();
  return response.data;
};
export const fetchSavedSearches = async (tab) => {
  let url = "/api/v1/SavedSearches/GetSavedSearches";
  if (tab) url = url + `?tab=${tab}`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    method: "get"
  });
  const response = await request.run();
  return response.data;
};
export const downloadFile = async function (endpoint,payload) {
  try {
    
    if (!config) {
      config = await axios.get('./config/runtime.json').then(conf => conf.data);
    }


    const axiosInstance = axiosWAuth(config); // Get the instance with authorization

    
    const endpointUrl = '/api/v1/' + endpoint;
    // Make the POST request with responseType: 'blob'
    const response = await axiosInstance.post(endpointUrl, payload, {
      responseType: 'blob', // Ensure response is treated as a binary file
    });

    // Create a Blob URL for the downloaded file
    const url = URL.createObjectURL(response.data);

    // Extract the filename from headers, fallback to a default
    const contentDisposition = response.headers['content-disposition'] || '';
    let fileName = 'downloaded_file.csv'; // Default fallback

    // Match filename*=UTF-8''... or fallback to filename=
    const filenameRegex = /filename\*=UTF-8''([^;]+)|filename=([^;]+)/;

    const matches = contentDisposition.match(filenameRegex);
    if (matches) {
      if (matches[1]) {
        // Extract from filename* (UTF-8 encoded)
        fileName = decodeURIComponent(matches[1]);
      } else if (matches[2]) {
        // Extract from regular filename
        fileName = matches[2].replace(/"/g, '');
      }
    }

    // Trigger the download
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; 
    a.click();

    // Cleanup
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('File download failed:', error);
  }
}